import React from 'react'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'

type MutableArea = {
  height?: number | string | null
  width?: number | string | null
  [key: string]: unknown
}

type FormArea = { height?: number | string | null; width?: number | string | null }
type FormAreaErrors = { height?: string; width?: string }
type FormAreaTouched = { height?: boolean; width?: boolean }

type Values = {
  article?: { areas?: FormArea[]; bodyNumberOfRows?: number | null } | null
  rows?: number
}

type Errors = {
  article?: { areas?: FormAreaErrors[] }
  rows?: string
}

type Touched = {
  article?: { areas?: FormAreaTouched[] }
  rows?: boolean
}

type Props = {
  values: Values
  errors: Errors
  touched: Touched
  setFieldValue: (field: string, value: unknown) => void
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
}

export const SizeFields = ({ values, errors, touched, setFieldValue, handleChange, handleBlur }: Props) => {
  return (
    <Row>
      <Form.Group as={Col}>
        <Form.Label column>記事サイズ指定</Form.Label>
        <Row>
          <Form.Group as={Col} sm={4}>
            <InputGroup size='sm' hasValidation>
              <InputGroup.Text>高さ</InputGroup.Text>
              <Form.Control
                type='number'
                name='article.areas[0].height'
                value={parseInt(String(values.article?.areas?.[0]?.height ?? '')) || ''}
                placeholder='ナリ'
                onChange={(e) => {
                  const areas = [{ ...values.article?.areas?.[0] }] as MutableArea[]
                  areas[0].height = e.target.value
                  const newArticle = {
                    ...values.article,
                    areas
                  }
                  setFieldValue('article', newArticle)
                }}
                onBlur={handleBlur}
                isInvalid={!!(touched.article?.areas?.[0]?.height && errors.article?.areas?.[0]?.height)}
              />
              <InputGroup.Text>段</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors.article?.areas?.[0]?.height}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} sm={4}>
            <InputGroup size='sm' hasValidation>
              <InputGroup.Text>横幅</InputGroup.Text>
              <Form.Control
                type='number'
                name='article.areas[0].width'
                value={parseInt(String(values.article?.areas?.[0]?.width ?? '')) || ''}
                placeholder='ナリ'
                onChange={(e) => {
                  const areas = [{ ...values.article?.areas?.[0] }] as MutableArea[]
                  areas[0].width = e.target.value
                  const newArticle = {
                    ...values.article,
                    areas
                  }
                  setFieldValue('article', newArticle)
                }}
                onBlur={handleBlur}
                isInvalid={!!(touched.article?.areas?.[0]?.width && errors.article?.areas?.[0]?.width)}
              />
              <InputGroup.Text>行</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors.article?.areas?.[0]?.width}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} sm={4}>
            <InputGroup size='sm' hasValidation>
              <InputGroup.Text>行数</InputGroup.Text>
              <Form.Control
                type='number'
                name='rows'
                value={values?.rows ?? ''}
                placeholder='ナリ'
                onChange={(e) => {
                  handleChange(e)
                }}
                onBlur={handleBlur}
                isInvalid={!!(touched.rows && errors.rows)}
                aria-describedby='articleFixRowsHelp'
              />
              <InputGroup.Text>行</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors.rows}</Form.Control.Feedback>
            </InputGroup>
            <Form.Text id='articleFixRowsHelp' muted>
              (本文行数: {values.article?.bodyNumberOfRows} 行)
            </Form.Text>
          </Form.Group>
        </Row>
      </Form.Group>
    </Row>
  )
}
